// Détection automatique de l'environnement
const hostname = window.location.hostname;

let apiUrl = "https://sophia.aiexpertys.fr/api"; // Par défaut (Prod)

if (hostname.includes("dev") || hostname.includes("localhost")) {
    apiUrl = "https://dev.sophia.aiexpertys.fr/api"; // Dev
}

const API_URL = process.env.REACT_APP_API_URL || apiUrl;

export default API_URL; // Note: utilise export default (ES6) plutôt que module.exports